let instance = null;
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Draggable from "gsap/Draggable";

import MiniMasonry from "minimasonry";
import Accordion from "../components/Accordion";
import TabsDropdown from "../components/Tabs";
import VideoObserver from "../components/VideoObserver";
import HtmlVideoPlayer from "../components/HtmlVideoPlayer";
import VimeoVideoPlayer from "../components/VimeoVideoPlayer";
import Nav from "../components/Nav";
import Observer from "../components/Observer";
import ClassWatcher from "../components/ClassWatcher";
import BlockObserver from "../components/BlockObserver";
import CopyToClipboard from "../components/CopyToClipboard";
import Dialog from "../components/Dialog";
import Pages from "../components/Pages";
import Buttons from "../components/Buttons";
import CarouselGSAP from '../components/CarouselGSAP';
import CollectionsCarousel from '../components/CollectionsCarousel';
import VideoCloud from '../components/VideoCloud';
import SidebarLinks from '../components/SidebarLinks';
import SearchTags from "../components/SearchTags";
import "../components/CookiesConsent";
import User from '../veritone/User';
import Asset from '../veritone/Asset';
import Collection from '../veritone/Collection';
import Onboarding from '../veritone/Onboarding';
import Modal from "../components/Modals";
import Order from "../veritone/Order";
import afterAjaxLoad from "../loading/afterAjaxLoad";
import Inspiration from "../components/Inspiration";



export default class App {
	constructor() {
		/**
		 * Setup Commands
		 */

		// make singleton
		if (instance) {
			return instance;
		}
		instance = this;

		// global access

		window.app = this;
		console.log('Cache check');

		// get context

		this.getContext();

		window.addEventListener("resize", () => {
			this.getContext();
			checkScreenSize()
		});

		this.copyUrlParams = document.getElementById('copy-url-params');
		this.copyUrlParams && this.copyUrlParams.addEventListener("click", (event) => {
			event.preventDefault();

			let originalHoverText  = this.copyUrlParams.dataset.tooltip;
			this.copyUrlParams.dataset.tooltip = 'Copied';

			let copyText = document.getElementById("queryString");

			copyText.select();
			copyText.setSelectionRange(0, 99999); // For mobile devices

			// Copy the text inside the text field
			let url = location.protocol + '//' + location.host + location.pathname + '?';
			navigator.clipboard.writeText(url+copyText.value);
			console.log("Copied the text: " + copyText.value);

			setTimeout(() => {
				this.copyUrlParams.dataset.tooltip = originalHoverText;
			}, 5000);
		})

		this.showSensitiveButtons = document.querySelectorAll('.show-sensitive');
		this.showSensitiveButtons && this.showSensitiveButtons.forEach((button)=>
		{
			button.addEventListener("click", (event) => {
				button.closest('.tile-video, .tile-video-list, .tile-video-basic').classList.remove('tile--sensitive');
			});
		})

		this.singleCollectionTabs = document.querySelectorAll('body.single-collection .filters .tab');
		this.singleCollectionTabs && this.singleCollectionTabs.forEach((button)=>
		{
			button.addEventListener("click", (event) => {
				let collectionFilters = document.getElementById('filters').offsetTop;
				window.scrollTo({ top: collectionFilters, behavior: 'smooth'});
			});
		})

		this.masonry = document.querySelector('[data-component="masonry"]');
		this.masonry && window.addEventListener("load", (event) => {
			var masonry = new MiniMasonry({
				container: '[data-component="masonry"]',
				surroundingGutter: false,
				gutter: 32,
				gutterY: 62,
				ultimateGutter: 32,
				baseWidth: 300,
			});
		});

		// SCROLLTRIGGER
		gsap.registerPlugin(ScrollTrigger, Draggable)

		const checkScreenSize = ()=>
		{
			if (window.app.isMobile) {

				if(window.app.smoother){
					window.app.smoother.kill()
				}

			} 
		}
		checkScreenSize()
		

		/**
		 * Components
		 */


		this.pageLoaders = document.querySelectorAll('[data-page]');
		this.pageLoaders && this.pageLoaders.forEach((pageLoader)=>
		{
			new Pages(pageLoader);
		})


		this.dialogs = document.querySelectorAll('[data-component="dialog"]');
		this.dialogs && this.dialogs.forEach((dialog)=>
		{
			new Dialog(dialog);
		})

		// this.largeDialogs = document.querySelectorAll('[data-component="largedialog"]');
		// this.largeDialogs && this.largeDialogs.forEach((dialog)=>
		// {
		// 	new LargeDialog(dialog);
		// })


		this.modals = document.querySelectorAll('[data-component="modal"]');
		this.modals && this.modals.forEach((modal)=>
		{
			new Modal(modal);
		})

		this.buttons = document.querySelectorAll('.btn');
		this.buttons && this.buttons.forEach((button)=>
		{
			new Buttons(button);
		})

		this.observer 			= new Observer();
		this.blockObserver		= new BlockObserver( document.querySelectorAll('[data-watch="true"]') ).init()
		this.CopyToClipboard 	= new CopyToClipboard();


		this.accordions = document.querySelectorAll('[data-component="accordion"]');
		this.accordions && this.accordions.forEach((accordion)=>{
			new Accordion(accordion).init();
		})

		this.tabs = document.querySelectorAll('[data-component="tabsdropdown"]');
		this.tabs && this.tabs.forEach((tab)=>
		{

			new TabsDropdown(tab).init();

		})

		this.nav = new Nav();
		//this.accordion = new Accordion();
		this.User = new User();
		this.Asset = new Asset();
		this.Collection = new Collection();
		this.Onboarding = new Onboarding();
		this.afterAjaxLoad = new afterAjaxLoad();
		this.inspiration = new Inspiration();

		this.VideoCloud = document.querySelector('.video-cloud');
		if(this.VideoCloud)
		{
			this.VideoCloud = new VideoCloud(this.VideoCloud);
		}

		this.htmlVideos = document.querySelectorAll('.video--html');
		this.htmlVideos && this.htmlVideos.forEach((video)=>
		{

			let options = {};

			if(video.dataset.muted === 'true') {
				options.autoplay = false;
				options.loop = true;
				options.muted = true;
				options.controls = true;
				options.cover = false;
			} else {
				options.autoplay = false;
				options.loop = true;
				options.muted = false;
				options.controls = true;
				options.cover = false;
			}

			if( video.classList.contains('video--autoplay') ){
				options.autoplay = true;
				options.muted = true;
				options.controls = false;
			}

			if( video.classList.contains('video--cover') ){
				options.cover = true;
			}
			
			new HtmlVideoPlayer(video, options);

		})

		this.hoverVideos = document.querySelectorAll('.video--hover');
		this.hoverVideos && this.hoverVideos.forEach((video)=>
		{

			let options = 
			{
				autoplay: false,
				loop: true,
				muted: true,
				controls: false,
				progress: false,
				cover: false,
				hoverToPlay: true,
			}

			if( video.classList.contains('video--cover') ){
				options.cover = true;
			}

			new HtmlVideoPlayer(video, options);

		})

		this.vimeoVideos = document.querySelectorAll('.video--vimeo');
		this.vimeoVideos && this.vimeoVideos.forEach((video)=>
		{
			let options = 
			{
				autoplay: true,
				loop: true,
				muted: true,
				controls: true,
				progress: true,
			}
			let player = new VimeoVideoPlayer(video, options);
		})

		this.carousels = document.querySelectorAll('[data-component="carousel"]');
		this.carousels && this.carousels.forEach((carousel)=>
		{
			
			new CarouselGSAP(carousel);

		})


		this.CollectionsCarousels = document.querySelectorAll('[data-component="collections-carousel"]');
		this.CollectionsCarousels && this.CollectionsCarousels.forEach((carousel)=>
		{
			
			new CollectionsCarousel(carousel);

		})

		this.footageBlocks = document.querySelectorAll('.footage');
		this.footageBlocks && this.footageBlocks.forEach((block)=>
		{

			let video = block.querySelector('video');
			
			block.addEventListener('mouseenter', () => 
			{
				video.click();
			})
			block.addEventListener('mouseleave', () => 
			{
				video.click();
			})

		})

		document.addEventListener("submit", (event) => {
			const shareCollectionAction = event.target.closest('#share-collection');
			if(shareCollectionAction) {
				event.preventDefault();
				this.Collection.veritoneShareCollection();
			}
		});

		this.shareCollectionLink = document.querySelectorAll('.share-collection-link');
		if(this.shareCollectionLink) {
			this.shareCollectionLink.forEach((button) => {
				button.addEventListener("click", (event) => {
					event.preventDefault();
					this.Collection.veritoneShareCollectionLink(button.dataset.collectionid);
				});
			});
		}

		// FOR SIDEBAR LINKS
		this.pageSections = document.querySelectorAll('[data-component="page-sections"]');
		this.pageSections && this.pageSections.forEach((section)=>{
			new SidebarLinks(section);
		})
	}
	getContext() {
		// Tells us if App is Mobile, and height of Viewport.

		if (window.matchMedia("(max-width: 600px)").matches) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}

		if (window.matchMedia("(hover: hover)").matches) {
			this.isHover = true;
		} else {
			this.isHover = false;
		}

		if (window.location.host.includes("localhost")) {
			this.URL =
				"http://" +
				window.location.host +
				`/${REPO}/wp-content/themes/${THEME}`;
		} else {
			this.URL =
				"https://" + window.location.host + `/wp-content/themes/${THEME}`;
		}

		this.vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${this.vh}px`);
	}
}